import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";
import { CreditCardModel } from "../models/credit-card.model";
import { PaymentResult } from "../models/payment-result.model";

export class CieloController {

    constructor(public _http: HttpClient) {

    }
    pay(creditCard: CreditCardModel, key: string, paymentId: number, parcels: number): Promise<PaymentResult> {



        return this._http.post(API_ADDRESS + `/cielo/pay/${key}/${paymentId}/${parcels}`, creditCard, httpOptionsDefault)
            .pipe(
                map(result => {


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: PaymentResult) => {


                return result;
            });

    }


    getInstructions(key: string, paymentId: number): Promise<any> {
        

        return this._http.get(API_ADDRESS + `/cielo/instructions/${key}/${paymentId}`, httpOptionsDefault)
            .pipe(
                map(result => {


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: PaymentResult) => {


                return result;
            });
    }

}


